import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { cloneArray, isDefined, sortReactTable } from '../../../utils';
import ZSearch from '../../Common/ZSearch';
import FreeTextQuestionIcon from '../../../icons/v3/FreeTextQuestionIcon';
import MultipleChoiceQuestionIcon from '../../../icons/v3/MultipleChoiceQuestionIcon';
import OpinionScaleQuestionIcon from '../../../icons/v3/OpinionScaleQuestionIcon';
import YesNotQuestionIcon from '../../../icons/v3/YesNotQuestionIcon';

const likertScales = [
    {
        id: 1,
        name: 'ASAT',
        displayText:'Overall, can you predict how satisfied the customer likely feels as a result of their service interaction with you?', 
        type: { id: 1, value: 'Opinion Scale', icon: <OpinionScaleQuestionIcon /> },
        choices: [
            {
                id: 1,
                value: 'Satisfied'
            }, {
                id: 2,
                value: 'Neutral'
            }, {
                id: 3,
                value: 'Dissatisfied'
            }]
    }, {
        id: 2,
        name: 'Resolution',
        displayText: 'Was the issue resolved and, if so, can you predict whether or not the customer is satisfied with the outcome?',
        type: { id: 3, value: 'Yes/No', icon: <YesNotQuestionIcon /> },
        choices: [
            {
                id: 1,
                value: 'Yes-Satisfied'
            }, {
                id: 2,
                value: 'Yes-Dissatisfied'
            }, {
                id: 3,
                value: 'No'
            }]
    },
    {
        id: 3,
        name: 'CSAT',
        displayText: 'Overall, can you predict how satisfied the customer is likely to be with the support experience?',
        type: { id: 1, value: 'Opinion Scale', icon: <OpinionScaleQuestionIcon /> },
        choices: [
            {
                id: 1,
                value: 'Satisfied'
            }, {
                id: 2,
                value: 'Neutral'
            }, {
                id: 3,
                value: 'Dissatisfied'
            }]
    },
    {
        id: 4,
        name: 'NPS',
        displayText: 'How likely is the customer to recommend our company to a friend or family member?',
        type: { id: 1, value: 'Opinion Scale', icon: <OpinionScaleQuestionIcon /> },
        choices: [
            {
                id: 1,
                value: 'Promoter'
            }, {
                id: 2,
                value: 'Passive'
            }, {
                id: 3,
                value: 'Detractor'
            }]
    },
];

const likertScalesCustomer = [
    {
        id: 1,
        type: { id: 1, value: 'Opinion Scale', icon: <OpinionScaleQuestionIcon /> },
        name: 'ASAT',
        displayText: 'Overall, how do you feel as a result of their service interaction with the customer service agent?',
        choices: [
            {
                id: 1,
                value: 'Satisfied'
            }, {
                id: 2,
                value: 'Neutral'
            }, {
                id: 3,
                value: 'Dissatisfied'
            }]
    }, {
        id: 2,
        type: { id: 3, value: 'Yes/No', icon: <YesNotQuestionIcon /> },
        name: 'Resolution',
        displayText: 'Was the issue resolved and, if so, are you satisfied with the outcome?',
        choices: [
            {
                id: 1,
                value: 'Yes-Satisfied'
            }, {
                id: 2,
                value: 'Yes-Dissatisfied'
            }, {
                id: 3,
                value: 'No'
            }]
    },
    {
        id: 3,
        type: { id: 1, value: 'Opinion Scale', icon: <OpinionScaleQuestionIcon /> },
        name: 'CSAT',
        displayText: 'Overall, how satisfied are you with the support experience?',
        choices: [
            {
                id: 1,
                value: 'Satisfied'
            }, {
                id: 2,
                value: 'Neutral'
            }, {
                id: 3,
                value: 'Dissatisfied'
            }]
    },
    {
        id: 4,
        type: { id: 1, value: 'Opinion Scale', icon: <OpinionScaleQuestionIcon /> },
        name: 'NPS',
        displayText: 'Would you recommend our company to a friend or family member?',
        choices: [
            {
                id: 1,
                value: 'Promoter'
            }, {
                id: 2,
                value: 'Passive'
            }, {
                id: 3,
                value: 'Detractor'
            }]
    },
];

class SelectQuestionFromTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: [],
            searchLikertScaleQuery: undefined,
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.onSearchLikertScale = this.onSearchLikertScale.bind(this);

        this.getScaleNode = this.getScaleNode.bind(this);
        this.getScalesNode = this.getScalesNode.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    onSearchLikertScale({ target }) {
        this.setState({ searchLikertScaleQuery: target.value });
    }

    getScaleNode(question) {
        const
            {
                onClose
            } = this.props;
        const choices = question.choices.map(c => <div key={c.id}>{c.value}</div>);
        return (<div className="frame-1000001446">
            <div className="flex-container">
                <div>
                    {question.name} - {question.displayText}
                </div>
                <div className="v3-button use-likert-scale flex-container-center"
                    style={{ width: '100px', margin: '10px' }} onClick={() => onClose(question)}>
                    use it
                </div>
            </div>
            <hr />
            {choices}
        </div>);

    }

    getScalesNode() {
        const
            {
                surveyType
            } = this.props;
        let scale0;
        let scale1;
        let scale2;
        let scale3;
        if (surveyType === "agent") {
            scale0 = this.getScaleNode(likertScales[0]);
            scale1 = this.getScaleNode(likertScales[1]);
            scale2 = this.getScaleNode(likertScales[2]);
            scale3 = this.getScaleNode(likertScales[3]);
        }
        else {
            scale0 = this.getScaleNode(likertScalesCustomer[0]);
            scale1 = this.getScaleNode(likertScalesCustomer[1]);
            scale2 = this.getScaleNode(likertScalesCustomer[2]);
            scale3 = this.getScaleNode(likertScalesCustomer[3]);
        }

        return (<div>
            <div className="flex-container-center">
                {scale0}
                {scale1}
            </div>
            <div className="flex-container-center">
                {scale2}
                {scale3}
            </div>
        </div>);
    }

    render() {
        const scalesNode = this.getScalesNode();
        return <div ref={this.wrapperRef}>
            <div>
                {/*
                <div style={{ marginBottom: '10px' }}>
                    <ZSearch placeHolder="Search..." searchValue={this.state.searchLikertScaleQuery} onChange={this.onSearchLikertScale} />
                </div>
                */ }
            </div>
            <div>
                {scalesNode}
            </div>
        </div>;
    };
}

const select = state => ({});
export default connect(select)(SelectQuestionFromTemplate);

